/* unplugin-vue-components disabled */import { render } from "./RefreshApp.vue?vue&type=template&id=4a4be408&scoped=true&ts=true"
import script from "./RefreshApp.vue?vue&type=script&lang=ts"
export * from "./RefreshApp.vue?vue&type=script&lang=ts"

import "./RefreshApp.vue?vue&type=style&index=0&id=4a4be408&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4be408"]])

export default __exports__